import {BaseResponseType} from "../shared-models/sharedTypes";
import { WidgetItemResult } from "./models/widgetTypes";
import {HttpClient} from "../../helpers";

export const WidgetService = {
    GetWidgetByReferenceId: async (referenceId: string) => {
        return await HttpClient.get<BaseResponseType<WidgetItemResult>>(`/api/Widget/GetWidgetByReferenceId/${referenceId}`);
    }
}
